/**
 * Lane C0-PROPS: where the kit's props stand on the 256 m plains. The placement is data in the shared layout now
 * (packages/shared data/layouts/plains.ts `PLAINS_PROPS`, lane C0-P1), so the rules lay the solid ones' tiles as
 * blocking (plainsMap.ts); this file gives it the kit's prop ids.
 */
import { plainsLayout } from '@nine/shared';
import type { PropId } from './props';

export interface Placed {
  readonly id: PropId;
  readonly at: plainsLayout.XY;
  /** It blocks walking (its tile is solid in the map). */
  readonly solid?: boolean;
}

/** The props of the 256 m plains, in placing order (the shared ids are the kit's). */
export const PLAINS_PROPS: readonly Placed[] = plainsLayout.PLAINS_PROPS satisfies readonly { readonly id: PropId }[];
